import { Util } from './util';
export class Diaria{
  id: number = null;
  dataI: Date = null;
  dataF: Date = null;
  qtde: number = null;
  valor: number = null;
  observacoes: string = null;
  ato: string = null;
  destino: string = null;
  motivo: string = null;

  constructor(d?){
    if (d) {
      this.id = d.id ? d.id : null;
      this.dataI = d.dataI ? d.dataI : null;
      this.dataF = d.dataF ? d.dataF : null;
      this.qtde = d.qtde ? d.qtde : null;
      this.valor = d.valor ? d.valor : null;
      this.observacoes = d.observacoes ? d.observacoes : null;
      this.ato = d.ato ? d.ato : null;
      this.destino = d.destino ? d.destino : null;
      this.motivo = d.motivo ? d.motivo : null;
    }

  }

  get periodo(): string{
    return Util.periodoMesAbreviado(this.dataI, this.dataF);
  }
}
